var map = {
	"./de.json": [
		66893,
		6893
	],
	"./en.json": [
		57161,
		7161
	],
	"./es.json": [
		52319,
		2319
	],
	"./fa.json": [
		61438,
		1438
	],
	"./fr.json": [
		35877,
		5877
	],
	"./hi.json": [
		60317,
		317
	],
	"./it.json": [
		79,
		79
	],
	"./ja.json": [
		2815,
		2815
	],
	"./ko.json": [
		38199,
		8199
	],
	"./pt_BR.json": [
		57895,
		7895
	],
	"./ro.json": [
		7514,
		7514
	],
	"./ru.json": [
		9574,
		9574
	],
	"./vi.json": [
		63976,
		3976
	],
	"./zh_CN.json": [
		61655,
		1655
	],
	"./zh_TW.json": [
		77344,
		7344
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 45356;
module.exports = webpackAsyncContext;